import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';
import {
    AUTH_PAGE,
    HINT_BLOCK,
    HINT_CARD,
    HINT_CONTAINER,
    HINT_SERIES,
    PLANNOGRAMM_ADDTASCK,
    PLANNOGRAMM_LIST,
    PLANNOGRAMM_TASK,
    SEARCH_CONTAINER,
    BAKERY_PRODUCTS,
    ROUTE_CONFIG,
    PRODUCT_OFFERS, CLAIMS, ORDERS, ORDERS_LIST, ORDERS_DETAILS,
} from "../utils/js/Const";
import SearchContainer from "../pages/searchContainer/SearchContainer";
import HintBlock from "../pages/Hint/HintBlock/HintBlock";
import HintCard from "../pages/Hint/HintCards/HintCard";
import HintContainer from "../pages/Hint/HintContainer/HintContainer";
import Auth from "../pages/UsAuth/Auth";
import PlannogrammList from "../pages/Plannogramm/PlannogrammList/PlanogrammList";
import PlannogrammAddTasck from "../pages/Plannogramm/PlannogrammAddTasck/PlannogrammAddTasck";
import PlannogrammTack from "../pages/Plannogramm/PlannogrammTasck/PlannogrammTack";
import HintSeries from "../pages/Hint/HintContainer/HintSeries";
import BakeryProducts from "../pages/Bakery/BakeryProducts";
import ProductOffersPage from "../pages/ProductOffersPage/ProductOffersPage";
import ClaimsPage from "../pages/Claims/ClaimsPage";
import OrdersPage from "../pages/OrdersPage/OrderPage/OrdersPage";
import OrderListGroup from "../pages/OrdersPage/OrderListGroup/OrderListGroup";
import OrderDetails from "../pages/OrdersPage/OrderDetails/OrderDetails";

const getRequiredRoles = (routePath) => {
    const config = ROUTE_CONFIG[routePath];
    if (!config) return [];
    return config.allowedRoles || [];
};

const AppRouter = () => {
    return (
        <Routes>
            {/* Публичный маршрут - страница входа */}
            <Route path={AUTH_PAGE} element={<Auth />} />

            {/* Защищенные маршруты */}
            <Route path={SEARCH_CONTAINER} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(SEARCH_CONTAINER)}>
                    <SearchContainer />
                </ProtectedRoute>
            } />

            <Route path={HINT_BLOCK} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(HINT_BLOCK)}>
                    <HintBlock />
                </ProtectedRoute>
            } />

            <Route path={HINT_CARD} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(HINT_CARD)}>
                    <HintCard />
                </ProtectedRoute>
            } />

            <Route path={HINT_CONTAINER} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(HINT_CONTAINER)}>
                    <HintContainer />
                </ProtectedRoute>
            } />

            <Route path={HINT_SERIES} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(HINT_SERIES)}>
                    <HintSeries />
                </ProtectedRoute>
            } />

            <Route path={PLANNOGRAMM_LIST} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(PLANNOGRAMM_LIST)}>
                    <PlannogrammList />
                </ProtectedRoute>
            } />

            <Route path={PLANNOGRAMM_ADDTASCK} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(PLANNOGRAMM_ADDTASCK)}>
                    <PlannogrammAddTasck />
                </ProtectedRoute>
            } />

            <Route path={PLANNOGRAMM_TASK} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(PLANNOGRAMM_TASK)}>
                    <PlannogrammTack />
                </ProtectedRoute>
            } />

            <Route path={BAKERY_PRODUCTS} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(BAKERY_PRODUCTS)}>
                    <BakeryProducts />
                </ProtectedRoute>
            } />

            <Route path={CLAIMS} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(CLAIMS)}>
                    <ClaimsPage />
                </ProtectedRoute>
            } />

            <Route path={PRODUCT_OFFERS} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(PRODUCT_OFFERS)}>
                    <ProductOffersPage />
                </ProtectedRoute>
            } />

            <Route path={ORDERS} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(ORDERS)}>
                    <OrdersPage />
                </ProtectedRoute>
            } />

            <Route path={ORDERS_LIST} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(ORDERS_LIST)}>
                    <OrderListGroup />
                </ProtectedRoute>
            } />

            <Route path={ORDERS_DETAILS} element={
                <ProtectedRoute requiredRoles={getRequiredRoles(ORDERS_DETAILS)}>
                    <OrderDetails />
                </ProtectedRoute>
            } />


            {/* Редирект с корня на /main (AuthProvider сам сделает правильный редирект) */}
            <Route path="/" element={<Navigate to={SEARCH_CONTAINER} replace />} />
            <Route path="*" element={<Navigate to={SEARCH_CONTAINER} replace />} />
        </Routes>
    );
};

export default AppRouter;
